/* 11 Oct round: home picks (bamboo, citrus, footer roots, fabric four stages shown still), spot options still + sty, max two drawing at once.
   Mula Blend: drawings pressed into the paper, drawn once; khadi paper grain; and the Timir colour swap (idea 3).
   10 Oct round: phone plates 08-17, spot options nx (name positions), cl (clearance for drawings without names),
   ref/reft/rr (region under a reference element), khadi paper.
   Config comes from <script id="MulaBlendCfg"> written by sections/mula-blend.liquid.
   Rules kept here: drawings only in empty gaps (never behind text or over photos), names >= 48 px (desktop) / 32 px (phone)
   from copy, draw once on view (~4.6 s), no motion with Reduce Motion. A drawing that does not fit is left out. */
(function () {
  var el = document.getElementById('MulaBlendCfg');
  if (!el) return;
  var C; try { C = JSON.parse(el.textContent); } catch (e) { return; }
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !C.motion;
  var DBG = /[?&]mbdebug=1/.test(location.search);
  var log = function () { if (DBG) console.log.apply(console, ['[MulaBlend]'].concat([].slice.call(arguments))); };
  var cache = {};
  function svgText(n) {
    if (!cache[n]) cache[n] = fetch(C.plates[n]).then(function (r) { if (!r.ok) throw 0; return r.text(); });
    return cache[n];
  }
  function dev() { var w = window.innerWidth; return w >= 990 ? 'd' : (w < 750 ? 'm' : ''); }

  /* ---------- free space ---------- */
  var TXT = 'h1,h2,h3,h4,h5,h6,p,li,dt,dd,blockquote,figcaption,label,small,strong,em,b,i,span,a,button,input,select,textarea,summary';
  function obstacles(host, clear) {
    var out = [], hr = host.getBoundingClientRect();
    host.querySelectorAll('img,picture,video,svg,canvas,iframe,button,input,select,textarea,' + TXT).forEach(function (n) {
      if (n.closest('.mb')) return;
      if (n.closest('svg') && n.tagName.toLowerCase() !== 'svg') return;
      var media = /^(IMG|PICTURE|VIDEO|CANVAS|IFRAME|svg)$/i.test(n.tagName);
      if (!media && !/^(BUTTON|INPUT|SELECT|TEXTAREA)$/.test(n.tagName)) {
        var own = false;
        for (var k = 0; k < n.childNodes.length; k++) { var c = n.childNodes[k]; if (c.nodeType === 3 && c.textContent.trim()) { own = true; break; } }
        if (!own) return;
      }
      var r = n.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) return;
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || +cs.opacity === 0) return;
      var pad = media ? 6 : clear;
      out.push([r.left - hr.left - pad, r.top - hr.top - pad, r.right - hr.left + pad, r.bottom - hr.top + pad]);
    });
    // drawings already placed in this host keep their own room
    host.querySelectorAll('.mb').forEach(function (m) {
      var r = m.getBoundingClientRect();
      out.push([r.left - hr.left - 24, r.top - hr.top - 24, r.right - hr.left + 24, r.bottom - hr.top + 24]);
    });
    return out;
  }
  // largest rectangle (in a cell grid) that best fits a box of aspect a (w/h)
  function bestRect(W, H, obs, a, cell, extra) { // extra: height kept for the names under the art (phone)
    var cols = Math.max(1, Math.floor(W / cell)), rows = Math.max(1, Math.floor(H / cell));
    var g = new Uint8Array(cols * rows);
    obs.forEach(function (o) {
      if (o[2] < 0 || o[3] < 0 || o[0] > W || o[1] > H) return;
      var x0 = Math.max(0, Math.floor(o[0] / cell)), x1 = Math.min(cols - 1, Math.floor(o[2] / cell));
      var y0 = Math.max(0, Math.floor(o[1] / cell)), y1 = Math.min(rows - 1, Math.floor(o[3] / cell));
      for (var y = y0; y <= y1; y++) for (var x = x0; x <= x1; x++) g[y * cols + x] = 1;
    });
    var h = new Int32Array(cols), best = null, bestS = 0;
    for (var y = 0; y < rows; y++) {
      for (var x = 0; x < cols; x++) h[x] = g[y * cols + x] ? 0 : h[x] + 1;
      var st = [];
      for (var x2 = 0; x2 <= cols; x2++) {
        var hh = x2 < cols ? h[x2] : 0, start = x2;
        while (st.length && st[st.length - 1][1] >= hh) {
          var t = st.pop(), w = x2 - t[0], rh = t[1];
          if (rh > 0) {
            var bw = w * cell, bh = rh * cell, s = Math.min(bw, (bh - (extra || 0)) * a); // fitted width
            if (s > bestS) { bestS = s; best = [t[0] * cell, (y - rh + 1) * cell, bw, bh]; }
          }
          start = t[0];
        }
        st.push([start, hh]);
      }
    }
    return best;
  }

  /* ---------- drawing ---------- */
  function fitStrokes(svg) {
    var vb = svg.viewBox.baseVal, w = parseFloat(svg.style.width) || svg.getBoundingClientRect().width || 1, k = vb.width / w * 0.62; // rotated: use its own width
    svg.querySelectorAll('g[stroke-width]').forEach(function (g) {
      var w0 = +(g.dataset.w || (g.dataset.w = g.getAttribute('stroke-width')));
      g.setAttribute('stroke-width', Math.max(w0 * k, k * 0.75).toFixed(2));
    });
  }
  function prepDraw(svg) {
    var o = (svg.getAttribute('data-o') || '0 0').split(' ').map(Number), items = [], tot = 0;
    svg.querySelectorAll('g').forEach(function (g, gi) {
      g.querySelectorAll('path').forEach(function (p) {
        var L = p.getTotalLength(), s = p.getPointAtLength(0);
        items.push({ p: p, L: L, k: gi * 1e5 + Math.hypot(s.x - o[0], s.y - o[1]) });
        p.setAttribute('pathLength', '1');
      });
    });
    items.sort(function (a, b) { return a.k - b.k; });
    items.forEach(function (it) { tot += it.L; });
    var acc = 0;
    items.forEach(function (it) { it.p.style.setProperty('--d', (acc / (tot || 1)).toFixed(4)); acc += it.L; });
  }
  // At most two drawings draw at the same time; the next one starts when one finishes (~4.6 s).
  var busy = 0, wait = [];
  function pump() {
    while (busy < 2 && wait.length) {
      var w = wait.shift(); busy++;
      w.classList.add('mb--on');
      setTimeout(function () { busy--; pump(); }, 4700);
    }
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); wait.push(e.target); } });
    pump();
  }, { threshold: 0.25 }) : null;

  function names(spot) {
    if (!spot.n) return '';
    var X = spot.nx; // optional: each name centred at a fraction of the drawing's width (a row of drawings)
    return '<div class="mb__names mb__names--' + (X ? 'x' : (spot.na || 'c')) + '">' + spot.n.map(function (n, i) {
      return '<span class="mb__name"' + (X ? ' style="left:' + (X[i] * 100).toFixed(1) + '%"' : '') + '><b>' + n[0] + '</b><i>' + n[1] + '</i></span>';
    }).join('') + '</div>';
  }

  // Shopify wraps each section in a plain div. Step down to the single child that fills it,
  // so the drawing sits on the element that paints the background (else that background covers it).
  function paintHost(h) {
    for (var i = 0; i < 4; i++) {
      var kids = [].filter.call(h.children, function (c) { return !/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(c.tagName) && !c.classList.contains('mb'); });
      if (kids.length !== 1) break;
      var a = h.getBoundingClientRect(), b = kids[0].getBoundingClientRect();
      if (Math.abs(a.width - b.width) > 2 || Math.abs(a.height - b.height) > 4) break;
      h = kids[0];
    }
    return h;
  }

  function place(spot, d) {
    var host = document.querySelector(spot.a);
    if (!host) { log('no host', spot.id); return; }
    host = paintHost(host);
    if (spot.need && !document.querySelector(spot.need)) return;
    return svgText(spot.p).then(function (txt) {
      if (getComputedStyle(host).position === 'static') host.classList.add('mb-host--rel');
      host.classList.add('mb-host');
      var wrap = document.createElement('div');
      wrap.className = 'mb mb--' + (spot.sty || (spot.ink ? 'ink' : 'press')) + (spot.f ? ' mb--fade' : '') + (RM || spot.still ? ' mb--still' : '');
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.zoom = '1'; // the product page zooms its own blocks on phones; the drawing keeps true px
      wrap.innerHTML = '<div class="mb__art">' + txt + '</div>' + names(spot);
      var svg = wrap.querySelector('svg');
      svg.removeAttribute('width'); svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      var vb = svg.viewBox.baseVal, rot = spot.rot || 0;
      var a = (rot % 180 === 0) ? vb.width / vb.height : vb.height / vb.width; // aspect of the drawn box
      var HR = host.getBoundingClientRect();
      // region inside the host, in px; r = [left, top, right, bottom] as fractions of the host box
      var R = spot.r || [0, 0, 1, 1], rx, ry, rw, rh;
      if (spot.rp) { // px from the host's edges; negative = from the right / bottom
        var P = spot.rp, px = function (v, L) { return v < 0 ? L + v : v; };
        rx = px(P[0], HR.width); ry = px(P[1], HR.height); rw = px(P[2], HR.width) - rx; rh = px(P[3], HR.height) - ry;
      } else { rx = R[0] * HR.width; ry = R[1] * HR.height; rw = (R[2] - R[0]) * HR.width; rh = (R[3] - R[1]) * HR.height; }
      if (spot.ref) { // region under a reference element: rr = [dx left, dy from its bottom, dx right, dy from its bottom]
        var refs = [].filter.call(host.querySelectorAll(spot.ref), function (e) { return !spot.reft || e.textContent.indexOf(spot.reft) > -1; });
        if (!refs.length) { log('no ref', spot.id); return; }
        var FR = refs[0].getBoundingClientRect(), Q = spot.rr || [0, 0, 0, 60];
        rx = FR.left - HR.left + Q[0]; ry = FR.bottom - HR.top + Q[1]; rw = FR.width - Q[0] + Q[2]; rh = Q[3] - Q[1];
      }
      var clear = spot.n ? (d === 'd' ? 48 : 32) : (spot.cl != null ? spot.cl : (d === 'd' ? 28 : 18));
      var obs = obstacles(host, clear).map(function (o) { return [o[0] - rx, o[1] - ry, o[2] - rx, o[3] - ry]; });
      // A coloured block that only partly overlaps the region would cover part of the drawing: keep out of it.
      if (!spot.top) host.querySelectorAll('*').forEach(function (c) {
        if (c.closest('.mb')) return;
        var cs = getComputedStyle(c);
        if (cs.position === 'fixed' || cs.position === 'sticky') return; // bars that move with the scroll
        if (cs.backgroundColor === 'rgba(0, 0, 0, 0)' && cs.backgroundImage === 'none') return;
        var cr = c.getBoundingClientRect(), l = cr.left - HR.left - rx, t = cr.top - HR.top - ry, r2 = l + cr.width, b2 = t + cr.height;
        if (cr.width < 4 || cr.height < 4 || r2 <= 0 || b2 <= 0 || l >= rw || t >= rh) return;
        if (l <= 0 && t <= 0 && r2 >= rw && b2 >= rh) return; // holds the whole region: fine, the drawing goes inside it
        obs.push([l, t, r2, b2]);
      });
      var nameH = spot.n ? (d === 'd' ? 40 : 34) : 0, gap = spot.n ? 10 : 0;
      // the box must hold the art plus the names under it
      var cell = d === 'd' ? 8 : 6;
      var b = bestRect(rw, rh, obs, a, cell, d === 'm' ? nameH + gap : 0);
      if (!b) { log('no room', spot.id); return; }
      var maxW = (spot.mw || 1) * (d === 'd' ? 420 : 220);
      var bw = b[2], bh = b[3] - nameH - gap;
      var w = Math.min(bw, bh * a, maxW, spot.w || 1e9), h = w / a;
      var minW = spot.min || (d === 'd' ? 90 : 60);
      if (w < minW || h < (spot.minh || 70)) { log('too small', spot.id, Math.round(w), Math.round(h)); return; }
      // align inside the free box: default bottom-right
      var al = spot.al || 'br';
      var x = al.indexOf('l') > -1 ? b[0] : (al.indexOf('c') > -1 ? b[0] + (bw - w) / 2 : b[0] + bw - w);
      var y = al.indexOf('t') > -1 ? b[1] : (al.indexOf('m') > -1 ? b[1] + (b[3] - h - nameH - gap) / 2 : b[1] + b[3] - h - nameH - gap);
      // Sit on the innermost block that paints a colour under this spot, else that colour covers the drawing.
      // A block whose background is an image (a photo) is never drawn on: the drawing is left out.
      var L = HR.left + rx + x, T = HR.top + ry + y, Rr = L + w, B = T + h + nameH + gap, tgt = host, photo = false;
      host.querySelectorAll('*').forEach(function (c) {
        if (c.closest('.mb')) return;
        var cr = c.getBoundingClientRect();
        if (cr.left > L + 1 || cr.top > T + 1 || cr.right < Rr - 1 || cr.bottom < B - 1) return;
        var cs = getComputedStyle(c);
        if (cs.position === 'fixed' || cs.position === 'sticky') return;
        if (/url\((?!"?data:image\/svg)/.test(cs.backgroundImage)) photo = true;
        if (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' || cs.backgroundImage !== 'none') tgt = c;
      });
      if (photo) { log('on a photo, left out', spot.id); return; }
      if (tgt !== host) {
        if (getComputedStyle(tgt).position === 'static') tgt.classList.add('mb-host--rel');
        tgt.classList.add('mb-host');
        var TR = tgt.getBoundingClientRect();
        rx = L - TR.left; ry = T - TR.top; x = 0; y = 0;
      }
      wrap.style.left = Math.round(rx + x) + 'px';
      wrap.style.top = Math.round(ry + y) + 'px';
      wrap.style.width = Math.round(w) + 'px';
      if (spot.top) wrap.style.zIndex = '1'; // on top of same-colour paper blocks (they can be positioned); text and photos are still kept clear
      var art = wrap.querySelector('.mb__art');
      art.style.height = Math.round(h) + 'px';
      if (rot) { svg.style.width = Math.round(h) + 'px'; svg.style.height = Math.round(w) + 'px'; svg.style.maxWidth = svg.style.maxHeight = 'none'; svg.style.transform = 'translate(-50%,-50%) rotate(' + rot + 'deg)'; svg.classList.add('mb__rot'); }
      tgt.insertBefore(wrap, tgt.firstChild);
      fitStrokes(svg);
      if (!RM && !spot.still) { prepDraw(svg); if (io) io.observe(wrap); else wrap.classList.add('mb--on'); }
      log('placed', spot.id, Math.round(w) + 'x' + Math.round(h), 'at', Math.round(rx + x), Math.round(ry + y));
      return wrap;
    }).catch(function (e) { log('fail', spot.id, e); });
  }

  var placed = [], curDev = '';
  function run() {
    var d = dev();
    if (d === curDev) return;
    placed.forEach(function (w) { if (w && w.parentNode) w.parentNode.removeChild(w); });
    placed = []; curDev = d;
    if (!d || !C.drawings) return;
    var chain = Promise.resolve();
    (C.spots || []).forEach(function (s) {
      if (s.dev && s.dev !== d) return;
      if (s.menu) return; // menu drawings wait for the menu to open
      chain = chain.then(function () { return place(s, d); }).then(function (w) { if (w) placed.push(w); });
    });
  }
  // menu drawings: placed the first time the menu opens (once per visit)
  function menuWatch() {
    (C.spots || []).filter(function (s) { return s.menu; }).forEach(function (s) {
      var done = false;
      document.addEventListener('click', function () {
        if (done) return;
        setTimeout(function () {
          var host = document.querySelector(s.a);
          if (!host || !host.getClientRects().length || host.getBoundingClientRect().height < 50) return;
          var d = dev(); if (s.dev && s.dev !== d) return;
          done = true; place(s, d);
        }, 350);
      }, true);
    });
  }
  /* ---------- khadi paper: a faint grain on light paper blocks, added after load (never on photos or dark blocks) ---------- */
  function paper() {
    if (!C.paper) return;
    var de = document.documentElement;
    de.style.setProperty('--mb-pl', 'url("' + C.paper[0] + '")');
    de.style.setProperty('--mb-pd', 'url("' + C.paper[1] + '")');
    var go = function () {
      // pop-ups, drawers and bars that sit over the page keep their own look (the phone menu is paper, so it is allowed)
      var over = [].filter.call(document.body.querySelectorAll('*'), function (e) { return getComputedStyle(e).position === 'fixed' && !e.matches('.mula-mobile-menu'); });
      [document.body].concat([].slice.call(document.body.querySelectorAll('div,section,main,header,footer,article,aside,nav,details,figure,ul'))).forEach(function (e) {
        if (e.closest('.mb,svg,picture,video,form,[role="dialog"]')) return;
        for (var k = 0; k < over.length; k++) if (over[k].contains(e)) return;
        var cs = getComputedStyle(e);
        if (cs.backgroundImage !== 'none') return; // photos, gradients: left alone
        var m = cs.backgroundColor.match(/[\d.]+/g);
        if (!m || (m.length > 3 && +m[3] < 1)) return; // transparent: the block under it carries the paper
        if ((0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255 < 0.82) return; // dark or strong colour
        if (e !== document.body && (e.offsetWidth < 160 || e.offsetHeight < 80)) return; // buttons, chips
        e.classList.add('mb-paper');
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 300);
  }

  function start() {
    paper();
    if (C.drawings) {
      run(); menuWatch();
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () {
        // re-fit when the layout changes width class; keep strokes crisp otherwise
        if (dev() !== curDev) run(); else document.querySelectorAll('.mb svg').forEach(fitStrokes);
      }, 200); });
    }
    if (C.swap) swap();
  }

  /* ---------- idea 3: Timir colour swap on the home shirts wall ---------- */
  function swap() {
    document.querySelectorAll('.mv-wall').forEach(function (root) {
      var rail = root.querySelector('[data-mv-rail]'), nav = root.querySelector('[data-mv-dots]');
      if (!rail || !nav) return;
      var tok = 0;
      nav.addEventListener('click', function (ev) {
        var b = ev.target.closest('.mv-wall__dot'); if (!b) return;
        ev.stopImmediatePropagation(); ev.preventDefault();
        var dots = [].slice.call(nav.querySelectorAll('.mv-wall__dot')), n = dots.indexOf(b);
        var slides = rail.querySelectorAll('.mv-ws'), cur = Math.round(rail.scrollLeft / (rail.clientWidth || 1));
        if (n < 0 || n === cur || !slides[n]) return;
        var my = ++tok, img = slides[n].querySelector('img'), out = slides[cur];
        dots.forEach(function (x) { x.removeAttribute('aria-busy'); }); b.setAttribute('aria-busy', 'true');
        var ready = img ? Promise.race([new Promise(function (res) {
          img.loading = 'eager';
          if (img.complete && img.naturalWidth) return res();
          img.addEventListener('load', res, { once: true }); img.addEventListener('error', res, { once: true });
        }).then(function () { return img.decode ? img.decode().catch(function () {}) : 0; }),
          new Promise(function (res) { setTimeout(res, 1500); })]) : Promise.resolve(); // never leave a tap waiting more than 1.5 s
        ready.then(function () {
          if (my !== tok) return;
          var parts = function (s) { return [s.querySelector('.mv-ws__img'), s.querySelector('.mv-ws__name')].filter(Boolean); };
          var fade = function (els, from, to, ms) {
            if (RM) return Promise.resolve();
            return Promise.all(els.map(function (e) { return e.animate([{ opacity: from }, { opacity: to }], { duration: ms, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).finished; }));
          };
          fade(parts(out), 1, 0, 120).then(function () {
            if (my !== tok) return;
            rail.scrollTo({ left: rail.clientWidth * n, behavior: 'instant' });
            dots.forEach(function (x, i) { x.setAttribute('aria-current', i === n ? 'true' : 'false'); }); // the theme's own tap handler is skipped
            parts(out).forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (a) { a.cancel(); }); });
            b.removeAttribute('aria-busy');
            return fade(parts(slides[n]), 0, 1, 120).then(function () {
              parts(slides[n]).forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (a) { a.cancel(); }); });
            });
          });
        });
      }, true);
    });
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
